// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'input-pen';

export const Component = () => (
  <path d='M23 10.5v13a1.502 1.502 0 0 1-1.5 1.5h-20A1.502 1.502 0 0 1 0 23.5v-20A1.502 1.502 0 0 1 1.5 2h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 1 1 0zm1.587-6.759L12.742 15.586a1.403 1.403 0 0 1-.999.414H9.941A.942.942 0 0 1 9 15.059v-1.802a1.404 1.404 0 0 1 .414-1L21.259.414a1.413 1.413 0 0 1 1.997 0l1.33 1.331a1.413 1.413 0 0 1 0 1.997zM21.995 4.92 20.08 3.005l-9.96 9.96a.404.404 0 0 0-.121.292V15h1.743a.403.403 0 0 0 .291-.12zM24 2.743a.412.412 0 0 0-.12-.292L22.549 1.12a.413.413 0 0 0-.583 0l-1.178 1.178 1.914 1.914 1.178-1.178a.41.41 0 0 0 .12-.29z' />
);

export const viewBox = '0 0 25 25';
